<!--
@Create By Tim For 19/08/13
@首页
-->
<template>
  <div class="Index">

    <!-- 轮播图 -->
    <div class="banner">
      <!-- 左侧菜单栏 -->
      <!-- <div class="bannerNav">
        <Menu />
      </div> -->
      <Banner />
    </div>

    <!-- 标题 -->
    <div class="caption">
      <span class="line"></span>
      <span class="txt">最新课程</span>
      <span class="line"></span>
    </div>

    <!-- 最新课程 -->
    <div class="newCourse">
      <NewCourse />
    </div>

    <!-- 标题 -->
    <div class="caption">
      <span class="line"></span>
      <span class="txt">热门课程</span>
      <span class="line"></span>
    </div>

    <!-- 热门课程 -->
    <div class="newCourse">
      <HotCourse />
    </div>

  </div>
</template>

<script>
import Banner from './Banner'
import NewCourse from './NewCourse'
import HotCourse from './HotCourse'
import Menu from './Menu'

export default {
  name: 'Index',
  data() {
    return {

    }
  },

  components: {
    Banner,
    NewCourse,
    HotCourse,
    Menu
  }


}
</script>

<style scoped>
.Index .banner {
  width: 1440px;
  height: 320px;
  margin: 0 auto 15px auto;
  position: relative;
}

.Index .banner .bannerNav {
  position: absolute;
  top: 0;
  left: 20px;
  z-index: 99;
  width: 210px;
  height: 320px;
}

.Index .caption {
  height: 50px;
  line-height: 50px;
  font-size: 20px;
  text-align: center;
  margin: 20px 0;
}

.Index .caption .line {
  display: inline-block;
  width: 50px;
  border-top: 1px solid #ccc;
}

.Index .caption .txt {
  color: #000;
  vertical-align: -8%;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Home.vue